/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import Swal from "sweetalert2";

import NewSLA from "./NewSLA";

import { getRequest } from "utils/request";
import { putRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { i18n } from '../../../translate/i18n'
import { useModal } from "hooks/modal";
import exportExcel from "utils/exportExcel";
import formatDate from "utils/formatDate";

export default function TabSLA({ match, listSLA, handleUpdate, handleUpdateSla, companyData }) {
  const [sla, setSLA] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newsla, setNewSLA] = useState(false);
  const [allsla, setAllSLA] = useState();
  const [selectedsla, setSelectedSLA] = useState({});
  const [companychannel, setCompanyChannel] = useState([]);
  const [CompanyChannelId, setSelectdCompanyChannel] = useState("0");
  const [companyticketype, setCompanyTicketType] = useState([]);
  const [CompanyTicketTypeId, setSelectdCompanyTicketType] = useState("0");
  const [companystatus, setCompanyStatus] = useState([]);
  const [CompanyStatusId, setSelectdCompanyStatus] = useState("0");
  const [globalFilter, setGlobalFilter] = useState('');
  const { toggleHelperId } = useModal();

  useEffect(() => {
    setAllSLA(listSLA);
    setSLA(listSLA);
  }, [match, listSLA]);

  useEffect(() => {

    getRequest(`/companieschannels?CompanyId=${match.params.id}`)
    .then(function (response) {
        setCompanyChannel(response.data);
        setLoading(false);
      }
    );

    getRequest(`/companiesticketstypes?CompanyId=${match.params.id}`)
    .then(function (response) {
        setCompanyTicketType(response.data);
        setLoading(false);
      }
    );
    getRequest(`/companiesstatus?CompanyId=${match.params.id}`)
      .then(function (response) {
          setCompanyStatus(response.data);
          setLoading(false);
        }
      );
  }, [loading, newsla, match.params.id]);

  const handleGoBack = () => {
    setSelectedSLA({});
    setNewSLA(!newsla);
  };

  const handleNewSLA = () => {
    handleUpdateSla();
    setNewSLA(!newsla);
  };

  const handleChannel = (e) => {
    const channelId = e.target.value;
    setSelectdCompanyChannel(e.target.value);

    if (
      channelId === "0" &&
      CompanyTicketTypeId === "0" &&
      CompanyStatusId === "0"
    ) {
      setSLA(allsla);
    } else {
      let slaFilter = allsla;
      if (channelId !== "0") {
        slaFilter = slaFilter.filter(
          (element) => element.ChannelId === Number(channelId)
        );
      }
      if (CompanyTicketTypeId !== "0") {
        slaFilter = slaFilter.filter(
          (element) =>
            element.CompanyTicketTypeId === Number(CompanyTicketTypeId)
        );
      }
      if (CompanyStatusId !== "0") {
        slaFilter = slaFilter.filter(
          (element) => element.CompanyStatusId === Number(CompanyStatusId)
        );
      }
      setSLA(slaFilter);
    }
  };

  const handleTicketType = (e) => {

    const ticketTypeId = e.target.value;
    setSelectdCompanyTicketType(e.target.value);

    if (
      CompanyChannelId === "0" &&
      ticketTypeId === "0" &&
      CompanyStatusId === "0"
    ) {
      setSLA(allsla);
    } else {
      let slaFilter = allsla;
      if (CompanyChannelId !== "0") {
        slaFilter = slaFilter.filter(
          (element) => element.ChannelId === Number(CompanyChannelId)
        );
      }
      if (ticketTypeId !== "0") {
        slaFilter = slaFilter.filter(
          (element) => element.CompanyTicketTypeId === Number(ticketTypeId)
        );
      }
      if (CompanyStatusId !== "0") {
        slaFilter = slaFilter.filter(
          (element) => element.CompanyStatusId === Number(CompanyStatusId)
        );
      }
      setSLA(slaFilter);
    }
  };

  const handleStatus = (e) => {

    const statusId = e.target.value;
    setSelectdCompanyStatus(e.target.value);

    if (
      CompanyChannelId === "0" &&
      CompanyTicketTypeId === "0" &&
      statusId === "0"
    ) {
      setSLA(allsla);
    } else {
      let slaFilter = allsla;
      if (CompanyChannelId !== "0") {
        slaFilter = slaFilter.filter(
          (element) => element.ChannelId === Number(CompanyChannelId)
        );
      }
      if (CompanyTicketTypeId !== "0") {
        slaFilter = slaFilter.filter(
          (element) =>
            element.CompanyTicketTypeId === Number(CompanyTicketTypeId)
        );
      }
      if (statusId !== "0") {
        slaFilter = slaFilter.filter(
          (element) => element.CompanyStatusId === Number(statusId)
        );
      }
      setSLA(slaFilter);
    }
  };

  const handleEditSLA = (data) => {
    setSelectedSLA(data);
    setNewSLA(!newsla);
  };

  const handleInativate = (id) => {
    Swal.fire({
      title: i18n.t('attemption'),
      text: i18n.t('deleteSLA'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t('confirmEraseCompany'),
    }).then((result) => {
      if (result.isConfirmed) {
        putRequest(`/companiesticketsyslas/inactivate/${id}`)
          .then(function (response) {
              if(response.success) {
                handleUpdate(6);
              } 
            }
          )
        }
    });
  };

  const header = (
    <div className="data-table-header"
    >
      <i className="pi pi-search" style={{paddingRight: 10}}></i>
      <input 
        className='input-globalfilter' 
        type="search" 
        onChange={(e) => setGlobalFilter(e.target.value)} 
        placeholder="Buscar" 
        icon="pi pi-search"/>
    </div>
  )

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{display: "flex", flexDirection: "row"}}>
        <div
          className="action-icon"
          style={{ cursor: "pointer", marginRight: 10 }}
          onClick={() =>  handleEditSLA(data)}
        >
          <i className="mdi mdi-pencil" style={{fontSize: 20}}></i>
        </div>
        <div
          className="action-icon"
          style={{ cursor: "pointer" }}
          onClick={() =>  handleInativate(data.id)}
        >
          <i className="mdi mdi-delete" style={{fontSize: 20}}></i>
        </div>
      </div>
    )
  }

  const channelDescriptionTemplate = (data) => {
    return(
      <span>{data.Channel.description}</span>
    )
  }

  const typeTemplate = (data) => {
    return(
      <span>{data.CompanyTicketType.description}</span>
    )
  }

  const statusTemplate = (data) => {
    return(
      <span>{data.CompanyStatus.internalDescription}</span>
    )
  }

  useEffect(() => {
    toggleHelperId(!newsla ? 38 : 39)
  }, [newsla])

  const handleExport = () => {
    let data = [];

    sla.forEach(e => {
      const slaAux = {
        [i18n.t('channel')]: e.Channel.description,
        [i18n.t('type')]: e.CompanyTicketType.description,
        [i18n.t('status')]: e.CompanyStatus.internalDescription,
        [i18n.t('deadLine')]: e.slaDurationDescription,
        [i18n.t('quantity')]: e.quantity,
        [i18n.t('message')]: e.defaultMessage,
        [i18n.t('createdAt')]: formatDate(e.createdAt)
      }

      data.push(slaAux);
    })

    exportExcel(data, 'SLA')
  }

  return (
    <div className="list-container">
      <div className="title-helper-container" style={{marginBottom: 10}}>
        <h3>{companyData.nickName}</h3>
        {!newsla && (
          <button style={{marginBottom: 5}} type="button" onClick={handleExport} className="export-excel" >
            <i style={{fontSize: 16, marginRight: 5}} className="pi pi-file-excel"/>  
            <span style={{fontSize: '1vw'}}>{i18n.t('exportAllData')}</span>
          </button>
        )}
      </div>
      {!newsla ? (
        <>
          <div className="tab-content">
            <h4>Filtros</h4>
            <div className="tab-pane show active" id="multi-item-preview">
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label>Canal</label>
                  <select
                    className="form-control select2"
                    data-toggle="select2"
                    required
                    value={CompanyChannelId}
                    onChange={handleChannel}
                  >
                    <option value="0">Selecione</option>
                    {companychannel.map((data, index) => (
                      <option key={index} value={data.Channel.id}>
                        {data.Channel.description}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-3">
                  <label>Tipo de Ticket</label>
                  <select
                    className="form-control select2"
                    data-toggle="select2"
                    required
                    value={CompanyTicketTypeId}
                    onChange={handleTicketType}
                  >
                    <option value="0">Selecione</option>
                    {companyticketype.map((data, index) => (
                      <option key={index} value={data.id}>
                        {data.description}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-3">
                  <label>Status</label>
                  <select
                    className="form-control select2"
                    data-toggle="select2"
                    required
                    value={CompanyStatusId}
                    onChange={handleStatus}
                  >
                    <option value="0">Selecione</option>
                    {companystatus.map((data, index) => (
                      <option key={index} value={data.id}>
                        {data.internalDescription}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {!loading ? (
              <DataTable 
                header={header}
                globalFilter={globalFilter}
                dataKey="id"
                rowsPerPageOptions={[5,10,25,50]} 
                value={sla}
                paginator
                rows={5} 
                emptyMessage={i18n.t('noSLAFinded')}
              >
                <Column body={channelDescriptionTemplate} filterField="Channel.description" header={i18n.t('channel')}></Column>
                <Column body={typeTemplate} filterField="CompanyTicketType.description" header={i18n.t('type')}></Column>
                <Column body={statusTemplate} filterField="CompanyStatus.internalDescription" header={i18n.t('status')}></Column>
                <Column field="slaDurationDescription" header={i18n.t('deadLine')}></Column>
                <Column field="quantity" header={i18n.t('quantity')}></Column>
                <Column body={actionButtonsTemplate} field="action" header={i18n.t('action')}></Column>
              </DataTable>
              ) : (
                <div className="area-loading">
                  <CircularProgress />
                </div>
              )}
            </div>
          </div>
          <div className="button-add-relative" onClick={() => setNewSLA(true)}>
            <i className="mdi mdi-plus"></i>
          </div>
        </>
      ) : (
        <NewSLA
          handleNewSLA={handleNewSLA}
          companyId={match.params.id}
          selectedsla={selectedsla}
          handleGoBack={handleGoBack}
          listChannel={companychannel}
          listTicketType={companyticketype}
          listStatus={companystatus}
        />
      )}
    </div>
  );
}
